module.exports = __webpack_public_path__ + "img/right8.c6cbc2d2.png";